module.exports = __webpack_public_path__ + "static/pic02-5ba84a7b8927d645f4db8c074028331f.jpg";